"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var NumberUtils_1 = require("../Utils/NumberUtils");
var ObjUtils_1 = require("../Utils/ObjUtils");
var TextUtils_1 = require("../Utils/TextUtils");
var Utils_1 = require("../Utils/Utils");
var UIAttributes_1 = require("./UIAttributes");
var UITransform = /** @class */ (function () {
    function UITransform() {
    }
    //#region Transformaciones para el UI PWA
    UITransform.getLayout = function (Source, parent, visibility) {
        var _this = this;
        var result = { attributes: this.getPropAttributes(Source, parent) };
        if (parent.hasChildNodes()) {
            var type_1 = Object.prototype.hasOwnProperty.call(UIAttributes_1.UI_ATTRIBUTES, parent.getName()) ? "controls" : "others";
            result[type_1] = [];
            parent
                .getChildren()
                .forEach(function (element) {
                return (!element.getName().equalsIgnoreCase(Utils_1.Utils.PROP_NAME) ||
                    (NumberUtils_1.default.SafeToInt(Source.NodePropertyValue(Utils_1.Utils.PROP_NAME, element.getAttrValue(Utils_1.Utils.PROP_ATTR_NAME), Utils_1.Utils.PROP_ATTR_VISIBLE), 1) &
                        visibility) >
                        0) &&
                    result[type_1].push(_this.getLayout(Source, element, visibility));
            });
        }
        return result;
    };
    UITransform.getLayoutAsync = function (Source, parent, visibility) {
        return __awaiter(this, void 0, void 0, function () {
            var result, type, _i, _a, element;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        result = { attributes: this.getPropAttributes(Source, parent) };
                        if (!parent.hasChildNodes()) return [3 /*break*/, 4];
                        type = Object.prototype.hasOwnProperty.call(UIAttributes_1.UI_ATTRIBUTES, parent.getName()) ? "controls" : "others";
                        result[type] = [];
                        _i = 0, _a = parent.getChildren();
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        element = _a[_i];
                        (!element.getName().equalsIgnoreCase(Utils_1.Utils.PROP_NAME) ||
                            (NumberUtils_1.default.SafeToInt(Source.NodePropertyValue(Utils_1.Utils.PROP_NAME, element.getAttrValue(Utils_1.Utils.PROP_ATTR_NAME), Utils_1.Utils.PROP_ATTR_VISIBLE), 1) &
                                visibility) >
                                0) &&
                            result[type].push(this.getLayout(Source, element, visibility));
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(function () { return resolve(); }, 1); })];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    UITransform.getPropAttributes = function (Source, Value, type) {
        if (type === void 0) { type = Utils_1.Utils.PROP_NAME; }
        var node;
        var PropName;
        if (typeof Value == "string") {
            node = Source.getNode(type, Utils_1.Utils.PROP_ATTR_NAME, Value);
            PropName = Value;
        }
        else {
            node = Value;
            PropName = node.getAttrValue(Utils_1.Utils.PROP_ATTR_NAME);
            type = node.getName();
        }
        var isPropNode = type.equalsIgnoreCase(Utils_1.Utils.PROP_NAME);
        if (ObjUtils_1.default.IsNothing(node))
            return {};
        var result = { node: type };
        for (var key in UIAttributes_1.UI_ATTRIBUTES[type]) {
            if (Object.prototype.hasOwnProperty.call(UIAttributes_1.UI_ATTRIBUTES[type], key)) {
                var element = UIAttributes_1.UI_ATTRIBUTES[type][key];
                try {
                    var AttrValue = this.developValue(Source, isPropNode, type, PropName, element); //
                    if (!TextUtils_1.default.isEmpty(AttrValue)) {
                        result[key] = this.normailzeWebAttribute(key, AttrValue);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
        return result;
    };
    UITransform.developValue = function (Source, isPropNode, PropType, PropName, element) {
        if (typeof element == "string")
            return this.getValue(Source, isPropNode, PropType, PropName, element);
        var retDefault = this.evaluateMacro(Source, "default" in element ? element["default"] : "");
        var retValue = "";
        if ("value" in element) {
            if (Array.isArray(element["value"])) {
                retValue = this.getArrayValue(Source, isPropNode, PropType, PropName, element["value"]);
            }
            else {
                retValue = this.getValue(Source, isPropNode, PropType, PropName, element["value"]);
            }
        }
        return TextUtils_1.default.isEmpty(retValue) ? retDefault : retValue;
    };
    UITransform.getArrayValue = function (Source, isPropNode, PropType, PropName, element) {
        var retValue = "";
        for (var i = 0; i < element.length && TextUtils_1.default.isEmpty((retValue = this.getValue(Source, isPropNode, PropType, PropName, element[i]))); i++) {
            // if (!TextUtils.isEmpty(retValue=this.getValue(Source,node,PropType,PropName,element[i])))
            //   break;
        }
        return retValue;
    };
    UITransform.getValue = function (Source, isPropNode, PropType, PropName, AttrName) {
        return isPropNode ? Source.FieldPropertyValue(PropName, AttrName) : Source.NodePropertyValue(PropType, PropName, AttrName);
    };
    UITransform.normalizeWebColor = function (value) {
        if (!value.startsWith("##") && value.startsWith("#") && value.length > 7) {
            return "#" + value.substr(value.length - 6, 6) + value.substr(1, value.length - 7).padStart(2, "0");
        }
        return value;
    };
    UITransform.normailzeWebAttribute = function (AttrName, value) {
        if (UIAttributes_1.COLOR_ATTRIBUTES.indexOf(AttrName) >= 0) {
            return this.normalizeWebColor(value);
        }
        return value;
    };
    UITransform.evaluateMacro = function (Source, macro) {
        if (!macro.startsWith("##"))
            return macro;
        if (macro.equals("##COMPANYCOLOR##"))
            return Source.getOwnerApp().getAppNode().attrs.companycolor || Utils_1.Utils.DEFAULT_BGCOLOR;
        if (macro.equals("##COMPANYFORECOLOR##"))
            return Source.getOwnerApp().getAppNode().attrs.forecolor || Utils_1.Utils.DEFAULT_FORECOLOR;
        return macro;
    };
    //#endregion
    //#region FieldPropertyValue
    UITransform.resolvedAttrName = function (AttrName) {
        if (UIAttributes_1.FAST_ATTR_RESOLVER.hasOwnProperty(AttrName))
            return UIAttributes_1.FAST_ATTR_RESOLVER[AttrName];
        return AttrName;
    };
    UITransform.setLayoutFieldPropertyValue = function (value, node, name, attrXoneName, attrValue) {
        var attrs = value === null || value === void 0 ? void 0 : value.attributes;
        var attrName = UITransform.resolvedAttrName(attrXoneName);
        if (attrs && attrs.node == node && attrs.name == name) {
            if (attrs.hasOwnProperty(attrName))
                attrs[attrName] = attrValue;
            else {
                // TODO: Luis esto ver con alejandro como se agrega una nueva
                attrs[attrName] = attrValue;
            }
            return true;
        }
        else if ((value === null || value === void 0 ? void 0 : value.controls) && Array.isArray(value.controls)) {
            for (var index = 0; index < value.controls.length; index++) {
                if (UITransform.setLayoutFieldPropertyValue(value.controls[index], node, name, attrXoneName, attrValue))
                    return true;
            }
        }
        return false;
    };
    UITransform.m_fastResolver = {};
    return UITransform;
}());
exports.default = UITransform;

//# sourceMappingURL=UITransform.js.map
